import React from 'react';
import ProductCard from './ProductCard';
import InventoryImageCard from './InventoryImageCard';
import './DASHBOARD.css';

// ProductSection 컴포넌트
const ProductSection = ({ category, onProductClick, onInventoryClick, onImageClick, onMoreClick, isLoggedIn }) => {
    const handleMoreClick = () => {
        let listType = 'all';
        // 자사재고현황을 먼저 체크 (더 구체적인 조건)
        if (category.title.includes('자사재고현황')) {
            listType = 'inventory';
        } else if (category.title.includes('잉여') || category.title.includes('재고')) {
            listType = 'surplus';
        } else if (category.title.includes('행사') || category.title.includes('품목')) {
            listType = 'event';
        }

        if (onMoreClick) {
            onMoreClick(listType);
        }
    };

    // 자사재고현황은 로그인하지 않으면 아예 렌더링하지 않음
    if (category.title.includes('자사재고현황') && !isLoggedIn) {
        return null; // 아예 렌더링하지 않음
    }

    return (
        <div className="dash-product-section">
            <div className="dash-section-header">
                <h2 className="dash-section-title">
                    {category.icon && <span className="dash-title-icon">{category.icon}</span>}
                    {category.title}
                </h2>
                {category.subtitle && (
                    <span className="dash-section-subtitle">{category.subtitle}</span>
                )}
                <button
                    className="dash-more-button"
                    onClick={handleMoreClick}
                >
                    더보기
                </button>
            </div>

            {/* 자사재고현황은 이미지 뷰로 렌더링 */}
            {category.title.includes('자사재고현황') ? (
                <div className="dash-inventory-image-grid">
                    {category.items.length > 0 ? (
                        category.items.map((inventory, index) => (
                            <InventoryImageCard key={`${inventory.itemCd}-${index}`} inventory={inventory} onImageClick={onImageClick} />
                        ))
                    ) : (
                        <div className="dash-no-data" style={{
                            gridColumn: '1 / -1',
                            padding: '40px',
                            textAlign: 'center',
                            color: '#666',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            border: '1px dashed #dee2e6'
                        }}>
                            등록된 자사재고가 없습니다.
                        </div>
                    )}
                </div>
            ) : (
                <div className="prd_grid">
                    {category.items.map(product => (
                        <ProductCard key={product.itemCd} product={product} onProductClick={onProductClick} isLoggedIn={isLoggedIn} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductSection;
